export var i18nModules;
(function (i18nModules) {
    i18nModules["TIERS"] = "tiers";
    i18nModules["AIDES"] = "aides";
    i18nModules["USER"] = "user";
    i18nModules["FORM"] = "form";
    i18nModules["PORTAL"] = "portal";
    i18nModules["JUSTIFICATION"] = "justification";
    i18nModules["TELESERVICE_OFFRES_STAGE_DEFAULT"] = "teleservice-offres-stage-default";
    i18nModules["OFFRESTAGE"] = "offreStage";
    i18nModules["CONTRIBUTIONS"] = "contributions";
    i18nModules["TELESERVICE_CONTRIBUTIONAVIS_DEFAULT"] = "teleservice-contributionAvis-default";
    i18nModules["TELESERVICE_DEMANDEPAIEMENT_DEFAULT"] = "teleservice-demandePaiement-default";
})(i18nModules || (i18nModules = {}));
//# sourceMappingURL=i18n-modules.js.map